import { FLIPPED_TIMEZONES } from "../constants";

/**
 * Get the short time zone name for any IANA time zone identifier (or a descriptive name mapped
 * to one via FLIPPED_TIMEZONES).
 * @param {string | undefined} input - The descriptive name or IANA time zone identifier.
 * @param {Date} [referenceDate=new Date()] - The date used to resolve daylight-saving time.
 * @returns {string | undefined} The short zone name (e.g. "EST", or a GMT offset if the runtime's
 * ICU data has no abbreviation for that zone), or undefined if it cannot be resolved.
 */
export const formatTimeZoneToAbbreviation = (input, referenceDate = new Date()) => {
  // Check if the input is a descriptive name and map it to a time zone identifier
  const timeZoneId = FLIPPED_TIMEZONES[input] || input;
  if (!timeZoneId) return undefined;

  try {
    // Intl computes the abbreviation dynamically, so it covers every IANA zone and is DST-aware
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: timeZoneId,
      timeZoneName: "short",
    }).formatToParts(referenceDate);
    return parts.find((part) => part.type === "timeZoneName")?.value;
  } catch {
    return undefined;
  }
};
